import Box from "@mui/material/Box";
import { useGridApiContext } from "@mui/x-data-grid";
import _ from "lodash";

export function DailySalesDataTableFooter(props) {
  const apiRef = useGridApiContext();
  const visableColumns = apiRef.current.getVisibleColumns();
  const { rowsdata } = props;
  if (!rowsdata || rowsdata.length <= 0) return;

  function Item(props) {
    const { sx, justifyContent = "flex-end", ...other } = props;
    return (
      <Box
        display="flex"
        sx={{
          p: 1,
          m: 1,
          bgcolor: (theme) => (other.children ? "grey.100" : ""),
          border: other.children ? "1px solid" : "",
          borderColor: (theme) => (other.children ? "grey.800" : ""),
          borderRadius: 2,
          fontSize: "0.875rem",
          fontWeight: "700",
          justifyContent,
          ...sx,
          fontColor: "red",
        }}
        {...other}
      />
    );
  }
  const sumOfTarget = _.sumBy(
    rowsdata,
    (r) => Number(r.target_total_amount) ?? 0,
  );
  const sumOfSales = _.sumBy(rowsdata, (r) => Number(r.work_total_amount) ?? 0);
  const sumOfVS = (sumOfSales / sumOfTarget) * 100;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          bgcolor: "background.paper",
          borderRadius: 1,
        }}
      >
        {_.map(visableColumns, (visableColumn) => {
          let value = "";
          let color = "";
          switch (visableColumn.field) {
            case "sales_vs_target":
              value = `${new Intl.NumberFormat("en", {
                minimumFractionDigits: 1,
              }).format(_.round(sumOfVS, 1))}%`;
              break;
            case "target_total_amount":
              value = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "HKD",
              }).format(sumOfTarget);
              break;
            case "work_total_amount":
              value = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "HKD",
              }).format(sumOfSales);

              break;
            default:
              break;
          }
          return (
            <Item
              color={color}
              key={visableColumn.field}
              flex={visableColumn.flex}
              width={visableColumn.computedWidth}
            >
              {value}
            </Item>
          );
        })}
      </Box>
    </>
  );
}
